import { memo } from 'react';

import styles from './styles.module.css';
import cx from 'clsx';
import { useMain } from './use-main';
import { ResultStep } from './steps/ResultStep';
import { useMicrositeAnalytics, useTrackTimeSpent } from 'src/hooks';

export const MainPage = memo(() => {
  useTrackTimeSpent();
  useMicrositeAnalytics();

  const { hasMedia, activeIndex, previousStepIndex, steps } = useMain();

  return (
    <>
      <main className={styles.main}>
        {hasMedia ? (
          <ResultStep />
        ) : (
          <div className={styles.stepsContainer}>
            {steps.map((step, index) => {
              const isActive = index === activeIndex;
              const isPrevious =
                index === previousStepIndex &&
                previousStepIndex !== activeIndex;
              const isAnimate = step.shouldAnimate && isPrevious;
              const StepComponent = step.Component;

              return (
                <div
                  key={step.key}
                  className={cx(styles.stepWrapper, {
                    [styles.stepActive]: isActive,
                    [styles.stepPrevious]: isPrevious,
                    [styles.stepAnimate]: isAnimate,
                    [styles.stepHidden]: !isActive && !isPrevious,
                  })}
                >
                  <StepComponent />
                </div>
              );
            })}
          </div>
        )}
      </main>
    </>
  );
});
